/*

  ? First, let's import the interface that will describe the shape of our chat states object.

*/

import StateInterface from "../state-interface";

/*

  & Now let's describe an initial state for the chat states object. This is the state that will be used when the app first fires up. Think of it like a placeholder.

*/

export const chat_states: StateInterface["chat_states"] = {
	screen: "chat_list",
	// The chat list's chip: all, unread, requirements or broadcasts (18 Oct 2026, the app's).
	chat_list_tab: "all",
	open_chat_modal: false,
	desktop_fullscreen_mode: false,
	chat_list: {
		chats: [],
		trigger_new_search: false,
		chats_loading: false,
		initial_load_done: false,
		chats_count: 0,
		total_unread_count: 0,
		filter_page_number: 0,
		all_chats_count: 0,
	},
	typing_chat_ids: [],
	broadcast_list: {
		broadcast: [],
		broadcast_ids: [],
		broadcasts: [],
		trigger_new_search: false,
		broadcasts_loading: false,
		initial_load_done: false,
		broadcasts_count: 0,
		pending_broadcasts_count: 0,
		filter_page_number: 0,
	},
	current_chat: {
		chat_id: "",
		chat_type: "",
		chat_title: "",
		chat_description: "",
		chat_dp: {
			file_id: "",
			url: "",
			video_metadata: {
				duration: 2,
				height: 720,
				width: 1280,
			},
			mime_type: "",
			original_file_server_path: "",
			exists: false,
		},
		is_broadcast: false,
		notification_settings: {
			is_business_profile: false,
			user_id: "",
			business_profile_id: "",
			is_muted: false,
			muted_till: "",
		},
		participants: [],
		messages: [],
		created_at: "",
		trigger_new_search: false,
		messages_loading: false,
		initial_load_done: false,
		messages_count: 0,
		filter_page_number: 0,
		selected_files: [],
		pending_uploads: [],
		current_message: "",
		invite_status: "",
	},
};
